import { Button, Tooltip } from "@mui/material";
import { TASK_STATUSES } from "../../constants/task";

export const TASK_COLUMN = (handleEditClick) => [

    {
        accessorKey: "taskId",
        header: "Ref No",
        size: 20,
    },
    {
        header: "Description",
        accessorKey: "description",
        Cell: ({ row }) => (
          <div>
            <Tooltip title={row.original.description} placement="top">
              <div
                style={{
                  width: "150px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {row.original.description}
              </div>
            </Tooltip>
          </div>
        ),
        size: 30,
      },
    {
        header: "Assigned By",
        size: 20,
        Cell: ({ row }) => {
          const { senderAgentName } = row.original;
          return senderAgentName ? senderAgentName : "Agency";
        },
      },      
    {
        accessorKey: "receiverAgentName",
        header: "Assigned To",
        size: 20,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 20,
      Cell: ({ cell }) => {
        const statusValue = cell.getValue();
        const statusObj = TASK_STATUSES.find(status => status.value === statusValue);
        return (
          <span>
            {statusObj?.label ?? 'Unknown'}
          </span>
        );
      }
    },
    {
        accessorKey: "taskReceivedDate",
        header: "Assigned Date",
        size: 30,
        Cell: ({ row }) => {
            const date = new Date(row.original.taskReceivedDate);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        }
    },
    {
        accessorKey: "deadLine",
        header: "Due Date",
        size: 30,
        Cell: ({ row }) => {
            const date = new Date(row.original.deadLine);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        }
    },
   {
    accessorKey: "deadLine",
    header: "Time Remaining",
    size: 30,
    Cell: ({ row }) => {
      const dueDate = new Date(row.original.deadLine);
      const now = new Date();
      const diff = dueDate - now;

      // Get status label if task is overdue
      const statusValue = row.original.status;
      const statusObj = TASK_STATUSES.find(
        (status) => status.value === statusValue
      );
      const statusLabel = statusObj?.label ?? "Unknown";

      if (diff <= 0) {
        return <span style={{ fontWeight: "bold" }}>{statusLabel}</span>;
      }

      // Convert milliseconds to days, hours, minutes
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      // Format the countdown
      let countdown = "";
      if (days > 0) countdown += `${days}d `;
      if (hours > 0 || days > 0) countdown += `${hours}h `;
      countdown += `${minutes}m`;

      return (
        <span style={{ color: "#52c41a", fontWeight: "bold" }}>
          {countdown}
        </span>
      ); // Always green
    },
  },
    {
      header: "Actions",
      id: "actions",
      size: 20,
      Cell: ({ row }) => (
        <Button
          size="small"
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation(); // Prevents row click event
            handleEditClick(row.original); // Trigger edit
          }}
        >
          Edit
        </Button>
      ),
    }
    
];